import * as React from "react";

import { cn } from "@/lib/utils";

/**
 * Deviation from the stock shadcn input: `autoComplete` defaults to `"off"`.
 *
 * This is an admin console — the operator is entering **someone else's**
 * details, so their own saved name/email/address are never the right value.
 * Left unset, the browser groups similar-looking unlabelled inputs and fills
 * them together: picking a suggestion in the Add-Employee "Full name" field
 * also wrote that value into the Employees page's search box behind the modal.
 *
 * Any field that genuinely wants browser assistance can still pass an explicit
 * `autoComplete` — the prop wins over this default.
 */
const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, autoComplete = "off", ...props }, ref) => {
    return (
      <input
        type={type}
        autoComplete={autoComplete}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
